import { css } from 'emotion';
import { ColumnProps } from '.';
import { mixins } from '../../utils/mixins';
import { SpatialOption } from '@joykit/variables/space/spatialValues';
import { ColumnSizeFraction, ColumnWidth, Screen, ColumnSizeNumber, ColumnSizeNumberWord } from '../../types';

const decimalToPercentageString = (num: number) => `${num * 100}%`;

const columnNumberToPercentage: { [x in ColumnSizeNumber]: string } = {} as any;
Array(12)
  .fill(undefined)
  .forEach((_, index) => {
    const columnNumber = index + 1;
    columnNumberToPercentage[columnNumber] = decimalToPercentageString(columnNumber / 12);
  });
export namespace styles {
  const getWidthByColumnNumber = (num: ColumnSizeNumber) => {
    return columnNumberToPercentage[num];
  };
  const getWidthByColumnString = (columnSizeFraction: ColumnSizeFraction | ColumnSizeNumberWord) => {
    switch (columnSizeFraction) {
      case 'one-quarter':
        return '25%';
      case 'one-third':
        return '33.3333%';
      case 'half':
        return '50%';
      case 'two-thirds':
        return '66.6666%';
      case 'three-quarters':
        return '75%';
      case 'full':
        return '100%';
      default:
        return undefined;
    }
  };

  const getColumnWidthValue = (columnWidth: ColumnWidth) => {
    return typeof columnWidth === 'number' ? getWidthByColumnNumber(columnWidth) : getWidthByColumnString(columnWidth);
  };

  const getMediaQueryForScreen = (screen: Screen, gapFactor: number, columnWidth?: ColumnWidth) => {
    if (!columnWidth) {
      return null;
    }

    let width = getColumnWidthValue(columnWidth);

    const rules = css({
      flex: 'none',
      width
    });

    return mixins.getMediaQueryForScreen(screen, gapFactor, rules);
  };

  const getMediaOffsetQueryForScreen = (screen: Screen, gapFactor: number, columnWidth?: ColumnWidth) => {
    if (!columnWidth) {
      return null;
    }

    let marginLeft = getColumnWidthValue(columnWidth);

    const rules = css({
      marginLeft
    });

    return mixins.getMediaQueryForScreen(screen, gapFactor, rules);
  };

  const getAllMediaQueries = (props: ColumnProps) => {
    const gapFactor = mixins.getGapFactor(props.columnGap || SpatialOption.default);
    const mobileMediaQueries = getMediaQueryForScreen('mobile', gapFactor, props.mobile);
    const mobileOffsetMediaQueries = getMediaOffsetQueryForScreen('mobile', gapFactor, props.mobileOffset);
    const tabletMediaQueries = getMediaQueryForScreen('tablet', gapFactor, props.tablet);
    const tabletOffsetMediaQueries = getMediaOffsetQueryForScreen('tablet', gapFactor, props.tabletOffset);
    const desktoptMediaQueries = getMediaQueryForScreen('desktop', gapFactor, props.desktop);
    const desktopOffsetMediaQueries = getMediaOffsetQueryForScreen('desktop', gapFactor, props.desktopOffset);
    const widescreenMediaQueries = getMediaQueryForScreen('desktop', gapFactor, props.desktop);
    const widescreenOffsetMediaQueries = getMediaOffsetQueryForScreen('desktop', gapFactor, props.desktopOffset);
    return [
      mobileMediaQueries,
      mobileOffsetMediaQueries,
      tabletMediaQueries,
      tabletOffsetMediaQueries,
      desktoptMediaQueries,
      desktopOffsetMediaQueries,
      widescreenMediaQueries,
      widescreenOffsetMediaQueries
    ];
  };

  export const container = (props: ColumnProps) => {
    const mediaQueries = getAllMediaQueries(props);
    return css(
      {
        display: 'block',
        flexBasis: 0,
        flexGrow: 1,
        flexShrink: 1
      },
      ...mediaQueries
    );
  };
}
